"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EH = void 0;
class ErrorHandler {
    constructor() {
        this.errorHandlers = [];
    }
    static getInstance() {
        if (!ErrorHandler.instance) {
            ErrorHandler.instance = new ErrorHandler();
        }
        return ErrorHandler.instance;
    }
    // todo:: implement different type of error handlers
    registerHandler(handler) {
        this.errorHandlers.push(handler);
    }
    error(e) {
        this.errorHandlers.forEach(handler => {
            handler(e);
        });
    }
}
exports.EH = ErrorHandler.getInstance();
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXJyb3JIYW5kbGVyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL3B1YmxpYy9zZXJ2aWNlcy9lcnJvckhhbmRsZXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsTUFBTSxZQUFZO0lBQWxCO1FBV1Usa0JBQWEsR0FBcUIsRUFBRSxDQUFDO0lBYS9DLENBQUM7SUF0QlEsTUFBTSxDQUFDLFdBQVc7UUFDdkIsSUFBSSxDQUFDLFlBQVksQ0FBQyxRQUFRLEVBQUU7WUFDMUIsWUFBWSxDQUFDLFFBQVEsR0FBRyxJQUFJLFlBQVksRUFBRSxDQUFDO1NBQzVDO1FBQ0QsT0FBTyxZQUFZLENBQUMsUUFBUSxDQUFDO0lBQy9CLENBQUM7SUFNRCxvREFBb0Q7SUFDN0MsZUFBZSxDQUFFLE9BQWlCO1FBQ3ZDLElBQUksQ0FBQyxhQUFhLENBQUMsSUFBSSxDQUFFLE9BQU8sQ0FBRSxDQUFDO0lBQ3JDLENBQUM7SUFFTSxLQUFLLENBQUUsQ0FBQztRQUNiLElBQUksQ0FBQyxhQUFhLENBQUMsT0FBTyxDQUFFLE9BQU8sQ0FBQyxFQUFFO1lBQ3BDLE9BQU8sQ0FBRSxDQUFDLENBQUUsQ0FBQztRQUNmLENBQUMsQ0FBQyxDQUFDO0lBQ0wsQ0FBQztDQUVGO0FBRVksUUFBQSxFQUFFLEdBQUcsWUFBWSxDQUFDLFdBQVcsRUFBRSxDQUFDIn0=